import template from './feasibility.html';
import controller from './feasibility.controller';

let feasibilityComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default feasibilityComponent;



// WEBPACK FOOTER //
// ./client/app/components/feasibility/feasibility.component.js